<craft-votes-counter class="count" [idea]="idea" [disabled]="disabled"></craft-votes-counter>
<button type="button" class="btn btn-vote" [disabled]="disabled" (click)="clicks.next($event)" [ngClass]="{ voted: idea.isVoted }">
  {{ idea.isVoted ? 'Voted' : 'Vote' }}
</button>
